import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { createTracker } from 'redux-segment';
import { apiMiddleware } from 'redux-api-middleware';

import rootReducer from './dux/rootReducer';
import { loadState, saveState } from './services/stateStorage';
import trackingAugmentor from './middleware/trackingAugmentor';
import apiConfig from './middleware/apiConfig';
import apiError from './middleware/apiError';

export const history = createBrowserHistory();
const tracker = createTracker();

const initialState = loadState();
const enhancers = [];
const middleware = [
  thunk,
  routerMiddleware(history),
  apiConfig, // Must come before apiMiddleware
  apiMiddleware, // Must come before all tracking-related middleware
  trackingAugmentor,
  tracker, // Must come after trackingAugmentor
  apiError, // Must come after apiMiddleware
];

if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_FEATURE_STAGING === 'staging') {
  const { __REDUX_DEVTOOLS_EXTENSION__ } = window;

  if (typeof __REDUX_DEVTOOLS_EXTENSION__ === 'function') {
    enhancers.push(__REDUX_DEVTOOLS_EXTENSION__());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const store = createStore(rootReducer(history), initialState, composedEnhancers);

store.subscribe(() => {
  saveState({
    user: store.getState().user,
    catalog: store.getState().catalog,
  });
});

export default store;
